import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewInterceptorDirective } from './view-interceptor.directive';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ ViewInterceptorDirective ],
    exports: [ ViewInterceptorDirective ],
})
export class ViewinterceptorDirectiveModule {}
